module.exports = __webpack_public_path__ + "static/img/henting3.63379b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/henting3.png
// module id = Awgd
// module chunks = 1